import { Button } from "@mui/material";
export default function FirstButton({
  buttonText,
  padding,
  margin,
  fontWeight,
  border,
  borderRadius,
  color,
  marginTop,
  float,
  onClick,
  className,
  disabled = false,
  width,
  backgroundColor,
  type = "button",
}) {
  return (
    <Button
      className={className}
      style={{
        padding,
        margin,
        fontWeight,
        border,
        borderRadius,
        color,
        marginTop,
        float,
        width,
        backgroundColor,
      }}
      type={type}
      disabled={disabled}
      onClick={(event) => {
        if (typeof onClick === "function") {
          onClick(event);
        }
      }}
    >
      {buttonText}{" "}
    </Button>
  );
}
